module.exports = __webpack_public_path__ + "img/Persepsi-Visual0.6053080d.png";